export default dispatch => {
  return {
    setUser: (data) => dispatch({ type: 'SETUSER' , payload: data }),
    clearUser: () => dispatch({ type: 'CLEARUSER' }),
    setConfig: (data) => dispatch({ type: 'SETCONFIG' , payload: data }),
    clearConfig: () => dispatch({ type: 'CLEARCONFIG' }),
    setLocation: (data) => dispatch({ type: 'SETLOCATION' , payload: data }),
    clearLocation: (data) => dispatch({ type: 'CLEARLOCATION' , payload: data }),
  }
};
